import React from 'react';
import Footer from '../Footer/Footer';
import './AboutUs.css';
import image from './../../assets/Images/aboutUs/homeImage.jpg';
import { Eye, Users, Flag, Award } from 'lucide-react';

const AboutUs = () => {
    return (
        <div className="ds-marketing about-us-page">
            {/* Full-width Header Section */}
            <div className="about-us-hero">
                <div className="about-hero-container">
                    <div className="about-hero-left-col">
                        <h1 className="about-hero-title-new">Our Journey: The DoCity Story</h1>
                        <p className="about-hero-sub-new">Transforming property verification with trust, transparency, and technology.</p>
                    </div>
                    <div className="about-hero-right-col">
                        <div className="about-hero-image-wrapper">
                            <img src={image} alt="About Us" className="about-hero-img-new" />
                        </div>
                    </div>
                </div>
            </div>

            {/* Why DoCity Section — full width */}
            <div className="about-why-section">
                <div className="about-why-inner">
                    <h2 className="about-section-heading">Why DoCity | How it Started</h2>
                    {/* CLAIM CHANGED. This sentence previously described the
                        DoCity Seal as "comprehensive title insurance that
                        protects your investment".

                        The product says the opposite of that in three places:
                        every certificate carries "DoCity does not take
                        responsibility for the title or possession of this
                        property", and certificates are issued on documents
                        "accepted as true to the best of the applicant's
                        knowledge". Title insurance is also a regulated product.
                        Describing the Seal as insurance while disclaiming title
                        is a mis-selling exposure, so the clause now states what
                        the Seal actually is.

                      
                        "thousands of transactions" claims. No such library
                        exists in any of the three front ends, but backend
                        systems are outside what can be verified from here, so
                        those are flagged rather than rewritten. */}
                    <p className="about-why-text">
                        DoCity was built to take the fear out of buying property. Too many buyers discover problems with ownership, documents, or planning only after they have paid, when it can be difficult and expensive to fix. We bring qualified civil engineers and technology together to help you assess a property with greater clarity and confidence before you commit. Our engineers carefully review property documents, ownership details, land use, property value, and relevant planning information to provide a clear and reliable assessment.Properties that complete the DoCity verification process may receive a certificate bearing the DoCity Seal, based on the applicable service and assessment outcome.
                    </p>
                </div>
            </div>

            {/* 4 Cards Grid — 2x2 balanced layout */}
            <div className="about-cards-section">
                <div className="about-cards-inner">
                    <div className="about-card">
                        <div className="about-card-icon-wrap">
                            <Eye size={22} className="about-card-icon" />
                        </div>
                        <h3 className="about-card-title">Our Vision</h3>
                        <div className="about-card-desc">
                            <p className="about-card-text">
                                Our goal is simple: to help buyers and property owners make confident decisions with a clear understanding of their property. DoCity connects you with qualified civil engineers who review the important property details and provide an independent assessment, so you can make decisions based on facts rather than uncertainty.
                            </p>
                        </div>
                    </div>

                    <div className="about-card">
                        <div className="about-card-icon-wrap">
                            <Users size={22} className="about-card-icon" />
                        </div>
                        <h3 className="about-card-title">Who We Are</h3>
                        <div className="about-card-desc">
                            <p className="about-card-text">
                                DoCity is a property verification service built by people with real experience in real estate and civil engineering. Our aim is to make property checks smart, affordable, and simple to use.
                            </p>
                        </div>
                    </div>

                    <div className="about-card">
                        <div className="about-card-icon-wrap">
                            <Flag size={22} className="about-card-icon" />
                        </div>
                        <h3 className="about-card-title">Our Mission</h3>
                        <div className="about-card-desc">
                            <p className="about-card-text">
                                To simplify the property journey through clear, accessible and trusted digital services, helping buyers and property owners manage verification, property information and self-declaration needs with greater clarity and confidence.
                            </p>
                            <p className="about-card-text about-card-text--sub">
                                <strong>Our Wider Goal:</strong> Over time, we aim to create opportunities for qualified civil engineers across India and beyond, building a trusted platform that makes professional property verification and assessment more accessible to property buyers and owners.
                            </p>
                        </div>
                    </div>

                    <div className="about-card">
                        <div className="about-card-icon-wrap">
                            <Award size={22} className="about-card-icon" />
                        </div>
                        <h3 className="about-card-title">Recognition</h3>
                        <div className="about-card-desc">
                            <p className="about-card-text">
                                The name DoCity stands for Doing better in Cities. As more of the country becomes urban, following the city master plan matters more than ever, and that idea sits at the heart of what we do.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default AboutUs;